import GuardianshipBasicInformation from "../../../../features/bonds/guardianship/components/BasicInformation";
import GuardianshipGeneralInformation from "../../../../features/bonds/guardianship/components/GeneralInformation";
import GuardianForm from "../../../../features/bonds/guardianship/components/Guardians";
import GuardianshipAttorneyInformation from "../../../../features/bonds/guardianship/components/AttorneyInformation";
import GuardianshipRequestorInformation from "../../../../features/bonds/guardianship/components/RequestorInformation";
import GuardianshipDocumentUpload from "../../../../features/bonds/guardianship/components/DocumentUpload";
import GuardianshipBillingInformation from "../../../../features/bonds/guardianship/components/BillingInformation";
import { ObligeeInformationForm } from "../Helpers/ObligeeInformation";
import {
  getSelectedStateLabel,
  standardStep,
} from "../bondWizardPageConfig.shared";

export default {
  layout: "standard",
  inlineTitle: () =>
    `Guardianship Bond Request for State of ${getSelectedStateLabel()}`,
  containerClassName: "p-6 max-w-4xl mx-auto",
  guestSupportContext: "Guest Guardianship Bond Request",
  hasDuplicateDialog: true,
  hasEsignatureDialog: false,
  duplicateBondUpdatePath: (bondId) =>
    `/vermost-guardianship-bond-update/${bondId}`,
  duplicateMessage:
    "A similar guardianship bond request appears to have been submitted within the last 24 hours. Do you still want to proceed?",
  getIsGuest: (form) => form.isGuestRequest,
  supportOnGoBack: ({ setSupportModalOpen }) => () => {
    setSupportModalOpen(false);
  },
  steps: [
    standardStep(GuardianshipBasicInformation, "basicInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.basicInformation,
      updateData: (data) => ctx.updateGlobalState("basicInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(
      GuardianshipGeneralInformation,
      "generalInformation",
      (ctx) => ({
        globalData: ctx.globalState,
        data: ctx.globalState.generalInformation,
        updateData: (data) => ctx.updateGlobalState("generalInformation", data),
        errors: ctx.errors,
        setErrors: ctx.setErrors,
      })
    ),
    standardStep(GuardianForm, "guardianDetails", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.guardianDetails,
      updateData: (data) => ctx.updateGlobalState("guardianDetails", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
      isGuest: ctx.isGuest,
    })),
    standardStep(
      GuardianshipAttorneyInformation,
      "attorneyInformation",
      (ctx) => ({
        globalData: ctx.globalState,
        data: ctx.globalState.attorneyInformation,
        updateData: (data) => ctx.updateGlobalState("attorneyInformation", data),
        errors: ctx.errors,
        setErrors: ctx.setErrors,
        isGuest: ctx.isGuest,
      })
    ),
    standardStep(ObligeeInformationForm, "obligeeInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.obligeeInformation,
      updateData: (data) => ctx.updateGlobalState("obligeeInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(
      GuardianshipRequestorInformation,
      "requestorInformation",
      (ctx) => ({
        globalData: ctx.globalState,
        data: ctx.globalState.requestorInformation,
        updateData: (data) =>
          ctx.updateGlobalState("requestorInformation", data),
        errors: ctx.errors,
        setErrors: ctx.setErrors,
      })
    ),
    standardStep(GuardianshipDocumentUpload, "documentUpload", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.documentUpload,
      updateData: (data) => ctx.updateGlobalState("documentUpload", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(GuardianshipBillingInformation, "billingInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.billingInformation,
      updateData: (data) => ctx.updateGlobalState("billingInformation", data),
      isGuest: ctx.isGuest,
    })),
  ],
};
